'use client'
import {
  IMAGE_QUERY
} from "./chunk-CWCKFIZP.mjs";

// src/api/common/category.ts
var CATEGORY_QUERY = `
id
title
slug
description
icon {${IMAGE_QUERY}}
background {${IMAGE_QUERY}}
color
`;

export {
  CATEGORY_QUERY
};
//# sourceMappingURL=chunk-ZZ3DUO5U.mjs.map